/**
 * iter-205 · Demo-funnel client tracker.
 *
 * Usage:
 *   import { trackDemoEvent } from "../../lib/demoEvents";
 *   trackDemoEvent("safe_number_viewed");
 *   trackDemoEvent("pricing_clicked", { plan: "Pro" });
 *
 * Always fire-and-forget. We guard against double-firing per session
 * for events that should be unique per visit (safe_number_viewed,
 * cash_breakdown_opened) via the optional ``once`` flag.
 */
import { api } from "./api";

const SESSION_KEY = "lumfi_demo_session_id";
const FIRED_PREFIX = "lumfi_demo_event_fired_";

function getOrCreateSessionId() {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return `s-${Date.now()}`;
  }
}

export async function trackDemoEvent(event, meta = {}, opts = {}) {
  const { once = false } = opts;
  if (once) {
    try {
      const k = FIRED_PREFIX + event;
      if (sessionStorage.getItem(k)) return { skipped: true };
      sessionStorage.setItem(k, "1");
    } catch {
      /* ignore */
    }
  }
  const session_id = getOrCreateSessionId();
  try {
    const r = await api.post("/demo/events/track", {
      event,
      session_id,
      slug: meta.slug,
      email: meta.email,
      demo_request_id: meta.demo_request_id,
      meta: meta.extra || {},
    });
    return r.data;
  } catch {
    return { error: true };
  }
}
